<template>
	<div  class="o-ndividualArea c-responsive-fixwidth">
        
		<div class="o-skills-listing">
		    <div class="row">
		        <div class="col col-sm-12">
		           <div class="o-scheduleTable--daily">
		              <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10" v-loading="loading"></div>
		                    <div v-for="employee in employees" class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table">
		                            <div class="calls-table-row">

		                                <div @click="goToEmployeeDetails(employee)"  class="calls-table-cell">
		                                    <div class="o-right-side-padding5">
		                                        <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
		                                            <div class="o-accordion-subtext user-icon o-list-user-img">
		                                                <div class="o-post-logged o-post-logged--table-user">
		                                                    <div class="o-user-profile-img o-header-profile-pic">
		                                                        <div v-if="employee.employable">
		                                                            <img v-if="employee.employable.image && employee.employable.image != '' &&employee.employable.image != 'NULL'" :src="(employee.employable.image)"  id='img-upload'/>
		                                                            <img v-if="!employee.employable.image && employee.employable.image == '' ||employee.employable.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload' />
		                                                        </div> 
		                                                    </div>
		                                                </div>
		                                            </div>
		                                            <div class="o-accordion-subtext o-rowtable-text">
		                                                <span>Name</span>
		                                                <div>{{employee.employable ? employee.employable.first_name+" "+employee.employable.last_name:'--'}}</div>
		                                            </div>
		                                        </div>
		                                    </div>
		                                </div>

		                                <div class="calls-table-cell">
		                                    <div class=" table-td-border-left o-left-side-padding5 o-right-side-padding5">
		                                        <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
		                                            <span class=""> Wishlist:</span>
		                                            <div class="notify-icon"><a href="javascript: void(0)" @click="goToWishlist(employee.id)"><i class="fa fa-star" aria-hidden="true"></i></a></div>
		                                        </div>
		                                    </div>
		                                </div> 
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right table-td-border-left o-left-side-padding5 o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">Schedule:</span>
                                                    <div class="notify-icon"><a href="javascript: void(0)" @click="goToSchedule(employee.id)"><i class="fa fa-eye" aria-hidden="true"></i></a></div>
                                                </div>
                                            </div>
                                        </div> 
		                            <div class="calls-table-cell">
		                                    <div class="table-td-border-right o-right-side-padding5 ">
		                                    <div class="calls-table-cell-inner-table">
		                                        <div class="o-accordion-subtext o-rowtable-text o-no-padding">
		                                            <span>Sen:</span>
		                                            <div>{{employee.seniority}}</div>
		                                        </div>
		                                    </div>
		                                </div>
		                            </div>

		                            <div class="calls-table-cell">
		                                <div class="table-td-border-right o-right-side-padding5">
		                                    <div class="o-accordion-subtext o-rowtable-text">
		                                        <span>Email ID:</span>
		                                        <div>{{employee.employable ? employee.employable.email:'--'}}</div>
		                                    </div>
		                                </div>
		                            </div>
		                            <div class="calls-table-cell">
		                                <div class="table-td-border-right o-right-side-padding5">
		                                    <div  class="o-accordion-subtext o-rowtable-text">
		                                        <span>Phone:</span>
		                                        <div v-if="employee.employable">
		                                            <div v-for="phone in employee.employable.phones" v-if="phone.label=='Home phone' || phone.label=='home'">{{phone.phone_number}}</div>
		                                        </div>
		                                    </div>
		                                </div>
		                            </div>
		                            <div class="calls-table-cell">
		                                <div class="table-td-border-right o-right-side-padding5">
		                                    <div class="o-accordion-subtext o-rowtable-text">
		                                        <span>Cell:</span>
		                                        <div v-if="employee.employable">
		                                            <div v-for="(phone,phoneIndex) in employee.employable.phones" :key="phoneIndex" v-if="phone.label=='Cell phone' ||  phone.label=='mobile' || phone.label=='cell'">{{phone.phone_number}}</div>
		                                        </div>
		                                    </div>
		                                </div>
		                            </div>

		                            <!-- <div class="calls-table-cell" :class="getPower('notify')?'':'notify-tab-hide'">
		                                <div class="o-right-side-padding5">
		                                    <div class="o-accordion-subtext o-rowtable-text o-notify-cell" :class="getPower('notify')?'':'notify-tab-hide'">
		                                        <span class="">Notify</span>
		                                        <div class="notify-icon">
		                                            <a href="javascript: void(0)" @click="addBatchNotify(employee)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
		                                        </div>
		                                    </div>
		                                </div>
		                            </div> -->
		                            <div class="calls-table-cell text-center o-no-padding">
		                                <div class="o-edit-trash o-no-padding">

		                                    <div class="o-table-block-btn">
		                                        <a href="javascript: void(0)" @click="editEmployee(employee)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
		                                    </div>
		                                    <div class="o-table-block-btn">
		                                        <a href="javascript: void(0)" class="disabled" @click="deleteEmployees(employee.id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
		                                    </div>

		                                </div>
		                            </div>
		                    </div>
		                    <div v-if="employees.length==0 && afterApi==true" class="o-ndividualTable">
		                        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
		                            <div class="col-md-12 no-job-dispaly">
		                                <i class="fa fa-frown-o" aria-hidden="true"></i>
		                                <br />
		                                No Data Stored{{afterApi}}
		                            </div>
		                        </div>
		                    </div>
		                </div>
		              </div>
		            </div>
		        </div>
		    </div>
		    <div v-if="employees.length==0 && afterApi" class="">
		        <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
		            <div class="col-md-12 no-job-dispaly">
		                <i class="fa fa-frown-o" aria-hidden="true"></i>
		                <br />
		                No Data Stored
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>
<script>
    import editEmployeePersonal from './editEmployeePersonal';
    import editEmployeeAdmin from './editEmployeeAdmin';
    import editEmployeeSkills from './editEmployeeSkills';
    import editEmployeeAvailability from './editEmployeeAvailability';
    import dateTimeConvert from '../../timeConvert&Compare.js';
    import {
        bus
    } from '../../main';
    import service from '../../services.js';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    let timeout=null;
    export default {

        components: {
            'editEmployeePersonal': editEmployeePersonal,
            'editEmployeeAdmin': editEmployeeAdmin,
            'editEmployeeSkills': editEmployeeSkills,
            'editEmployeeAvailability': editEmployeeAvailability
        },
        props: {
            searchString: {
                type: String,
                required: true
            },
            requestPage:{
            	type:String,
            	required:true
            }
        },
        data() {
            return {
                
                afterApi:false,
                loading:false,
                search_query:'',
                last_page:'',
                next_page:'',
                employees:[],
                savedEmployees:[],

            }
        },
        watch:{
        	searchString: function(data) {
        		this.search_query=data;
        		// this.getAllEmployee();
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if(this.search_query.length>0)
                        this.getAllEmployee();
                }, 1000);
        	}
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                currentEmployeeID: 'currentEmployeeID',
                getEditEmployeeFrom: 'getEditEmployeeFrom',
                employeeId:'employeeId',
            }),
        },
        methods: {
            getAllEmployee() {
                this.$Progress.start();
                this.loading = true;
                this.afterApi = false;
                this.employees=[];
                this.savedEmployees =[];
                service.get('employee/getEmployeesByClient', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'status': 'all',
                    'sort': 'fname_asc',
                    'search': this.search_query,
                    'pagination': true
                }).then((res) => {
                    this.employees = res.data.result.data;
                    //console.log("fffff", this.employees);
                    this.$Progress.finish();
                    this.last_page = res.data.result.total;
                    this.next_page = res.data.result.next_page_url;
                    this.loading = false;
                    this.afterApi = true;
                    //console.log("res", res.data.result.data[0].employable);
                    //this.sortEmployee();
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'status': 'all',
                            'sort': 'fname_asc',
                            'search': this.search_query,
                            'pagination': true
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    } 
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.afterApi = true;
                });
            },
            loadMore() {
                var arr = this.employees;
                if (this.savedEmployees.length != 0) {
                    this.savedEmployees.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.savedEmployees=[];
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'status': 'all',
                            'sort': 'fname_asc',
                            'search': this.search_query,
                            'pagination': true
                        }).then((res) => {
                            this.savedEmployees = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                } 
            },
            goToEmployeeList(){
                this.$router.push({
                    'path': '/employees'
                });
            },
            goToEmployeeDetails(employee) {
                this.$store.dispatch('selectEmployee', {
                    'id': employee.id,
                    'name': employee.employable.first_name + ' ' + employee.employable.last_name,
                    'type': employee.employable_type
                });
                this.$router.push({
                    path: '/employeeDetails/' + btoa(employee.id)
                });
            },
            editEmployee(employee) {
                this.$store.dispatch('selectEmployee', {
                    'id': employee.id,
                    'name': employee.employable.first_name + ' ' + employee.employable.last_name,
                    'type': employee.employable_type
                });
                this.$store.dispatch('setEditEmployeesFrom', 'editEmployeeList');
                
                this.$router.push({ name: 'editEmployee', params: { empId: btoa(employee.id) } })
                // this.getEmpDetails();
                if(this.requestPage=='edit-employee'){
                	bus.$emit('onsearchAction', 'edit-employee');
                }
            },
            goToSchedule(empId){
                this.$router.push({
                    'path': '/schedule/'+btoa(empId)
                });
                if(this.requestPage=='emp-schedule'){
                	bus.$emit('onsearchAction', 'emp-schedule');
                }
            },
            goToWishlist(id){
                this.$router.push({
                    path: `/wishlist/`+btoa(id)
                });

                if(this.requestPage=='wish-list'){
                    bus.$emit('onsearchAction', 'wish-list');
                }
            }
        },
        created() {
           this.search_query=this.searchString;
           this.getAllEmployee();
           // console.log(this.requestPage);
        },
    }

</script>


// WEBPACK FOOTER //
// src/components/employees/employeeSearch.vue